import React, { useEffect, useState } from "react";
import { Megaphone, Copy } from "lucide-react";
import { toast } from "../hooks/use-toast";

export function isPromoActive(promo) {
  if (!promo || !promo.enabled || !promo.text) return false;
  if (promo.starts_at && new Date(promo.starts_at) > new Date()) return false;
  return !promo.ends_at || new Date(promo.ends_at) > new Date();
}

function useCountdown(endsAt) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!endsAt) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [endsAt]);
  if (!endsAt) return null;
  const diff = Math.max(0, new Date(endsAt).getTime() - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, done: diff <= 0 };
}

export const PromoBanner = ({ promo }) => {
  const cd = useCountdown(promo?.ends_at);
  if (!isPromoActive(promo) || (cd && cd.done)) return null;
  const bg = promo.bg_color || "#f43f5e";
  const fg = promo.text_color || "#ffffff";
  const copy = () => {
    navigator.clipboard?.writeText(promo.discount_code);
    toast({ title: "Code copied", description: `${promo.discount_code} will be applied at checkout.` });
  };
  return (
    <div className="w-full" style={{ background: bg, color: fg }} data-testid="promo-banner">
      <div className="max-w-[1100px] mx-auto px-6 py-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
        <span className="flex items-center gap-2 font-semibold"><Megaphone size={16} /> <span data-testid="promo-banner-text">{promo.text}</span></span>
        {promo.discount_code && (
          <button onClick={copy} data-testid="promo-banner-code" className="inline-flex items-center gap-1.5 rounded-full border border-current/40 px-3 py-1 font-mono text-xs tracking-wider hover:opacity-80 transition-opacity" style={{ borderColor: fg }}>
            {promo.discount_code} <Copy size={12} />
          </button>
        )}
        {cd && (
          <span className="flex items-center gap-1 font-mono text-xs" data-testid="promo-countdown">
            Ends in
            {[["d", cd.d], ["h", cd.h], ["m", cd.m], ["s", cd.s]].map(([u, val]) => (
              <span key={u} className="rounded-md px-1.5 py-0.5 bg-black/15 tabular-nums">{String(val).padStart(2, "0")}{u}</span>
            ))}
          </span>
        )}
      </div>
    </div>
  );
};
